import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Svg = styled.svg `
  ${({ direction }) => direction === 'right' &&
    css `
      transform: rotate(-90deg);
    `}
  ${({ direction }) => direction === 'left' &&
    css `
      transform: rotate(90deg);
    `}
  ${({ direction }) => direction === 'top' &&
    css `
      transform: rotate(-180deg);
    `}
`;
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick, direction }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsx(Svg, { ref: ref, onClick: onClick, width: size, direction: direction, height: size, viewBox: '0 0 32 32', fill: fillColor, className: className, children: _jsx("path", { d: 'M30.090 8.583c-0.397-0.397-1.042-0.397-1.439 0l-12.651 12.676-12.676-12.676c-0.397-0.397-1.042-0.397-1.439 0s-0.397 1.042 0 1.439l13.371 13.371c0.198 0.198 0.447 0.298 0.719 0.298 0.248 0 0.521-0.099 0.719-0.298l13.371-13.371c0.422-0.397 0.422-1.042 0.025-1.439z' }) }));
});
export default React.memo(Icon);
